import myRequest from '@/services/myRequest';

export async function getPushExpressList(params) {
  return myRequest('get', '/auditContent/articlePushList', params);
}
export async function queryHotContent(params) {
  return myRequest('get', '/hotSearch/queryHotContent', params);
}
